import { FieldHookConfig, useField } from "formik";
import React from "react";
import { useStyles } from "./Styles";
import { useId } from "@fluentui/react-components";
import { ICartItemOptionGroup } from "../Schema";
import { CartItemOptionGroupLabel } from "./CartItemOptionGroupLabel";
import { SingleSelectOptionGroup } from "./SingleSelectOptionGroup";
import { MultiSelectOptionGroup } from "./MultiSelectOptionGroup";

interface CartItemOptionGroupProps {
  isAvailable: boolean;
}
export const CartItemOptionGroup = React.forwardRef<
  HTMLDivElement,
  CartItemOptionGroupProps & FieldHookConfig<ICartItemOptionGroup>
>(
  (
    props: CartItemOptionGroupProps & FieldHookConfig<ICartItemOptionGroup>,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const styles = useStyles();
    const [field, meta, helpers] = useField<ICartItemOptionGroup>({
      ...props,
    });

    const labelId = useId();
    const onBlur: React.FocusEventHandler<HTMLDivElement> = (
      e: React.FocusEvent<HTMLDivElement, Element>,
    ) => {
      helpers.setTouched(true);
      field.onBlur(e);
    };

    return (
      field?.value && (
        <div ref={ref} onBlur={onBlur} className={styles.field}>
          <CartItemOptionGroupLabel
            field={field}
            meta={meta}
            id={labelId}
            required={field.value.minimum > 0}
            role="button"
            aria-label={field.value.name}
          />
          {field.value.isSingleSelect ? (
            <SingleSelectOptionGroup
              disabled={!props.isAvailable}
              aria-required="true"
              aria-labelledby={labelId}
              optionGroup={field.value}
              setValue={(value: ICartItemOptionGroup) => {
                helpers.setValue(value);
              }}
            />
          ) : (
            <MultiSelectOptionGroup
              disabled={!props.isAvailable}
              aria-labelledby={labelId}
              className={styles.field}
              optionGroup={field.value}
              setValue={(value: ICartItemOptionGroup) => {
                helpers.setValue(value);
              }}
            />
          )}
        </div>
      )
    );
  },
);

CartItemOptionGroup.displayName = "CartItemOptionGroup";
